module.exports = __webpack_public_path__ + "static/media/Template-FedEx.3f085674.svg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/default/modules/channel/pages/Template-FedEx.svg
// module id = 3827
// module chunks = 0